import {
  compose,
  find,
  ifElse,
  isEmpty,
  isNil,
  join,
  map,
  prop,
  propEq,
  propOr,
  split,
  startsWith,
} from 'ramda'
import { stubNull } from 'ramda-adjunct'

import { PAGE_TYPE } from './constants'

// Describe all pages of the application by adding route objects to this array,
// a route object is made of the following fields:
//
// * id (string, mandatory, unique): unique id used to retrieve the path of the
//   page using getPagePath (so that we don't put hardcoded routes in the code)
//
// * path (string, mandatory, unique): the path of the page in the router
//   WARNING: must start with /
//
// * feature (string, mandatory): the path to the component (omitting /index.js)
//   relative to features folder, it is used to lazy load the page component
//   when the router resolves to this route
//
// * exact (boolean, optional, default: false): is the route resolved using the
//   exact property of react-router
//
// * pageName (string, optional, default: ''): the name of the page which will get concat to
//   form the title of the page for SEO (see the formatPageTitle function)
//
// * description (string, optional): the description of the page which will be
//   use for SEO
//
// * props (object, optional, default: {}): any props you need to pass from this
//   static router to a feature (i.e. page) component, given the static nature
//   of the router, this props will be unvarying.
const routes = [
  {
    id: 'login',
    path: '/login',
    exact: true,
    pageName: 'Connexion',
    feature: 'Login',
    isAuthenticationRequired: false,
  },
  {
    id: 'loginCallback',
    path: '/auth/callback',
    exact: true,
    pageName: 'Connexion',
    feature: 'AuthCallback',
    isAuthenticationRequired: false,
  },
  {
    id: 'logout',
    path: '/auth/logout',
    exact: true,
    pageName: 'Déconnexion',
    feature: 'Logout',
    isAuthenticationRequired: false,
  },
  {
    id: 'home',
    path: '/',
    exact: true,
    pageName: 'Accueil',
    feature: 'Home',
    type: PAGE_TYPE.HOME,
    isOnMainNav: true,
    isAuthenticationRequired: true,
  },
  {
    id: 'notFound',
    path: '/404',
    exact: true,
    pageName: '404',
    feature: 'NotFound',
    isAuthenticationRequired: false,
  },
  {
    id: 'estate',
    path: '/patrimoine',
    exact: true,
    pageName: 'Patrimoine',
    feature: 'Estate',
    type: PAGE_TYPE.MAIN_VIEW,
    isOnMainNav: true,
    isAuthenticationRequired: true,
  },
  {
    id: 'actions',
    path: '/actions',
    exact: true,
    pageName: 'Actions',
    feature: 'Actions',
    type: PAGE_TYPE.MAIN_VIEW,
    isOnMainNav: true,
    isAuthenticationRequired: true,
  },
  {
    id: 'dashBoard',
    path: '/dashBoard',
    exact: true,
    pageName: 'Tableau de bord',
    feature: 'Home',
    type: PAGE_TYPE.MAIN_VIEW,
    isOnMainNav: true,
    isAuthenticationRequired: true,
    isDisabled: true,
  },
  {
    id: 'housingDetails',
    path: '/bien/:subjectID',
    exact: true,
    pageName: 'Analyse par bien',
    feature: 'SubjectDetails',
    type: PAGE_TYPE.DETAILS,
    isOnMainNav: false,
    isAuthenticationRequired: true,
  },
]

// This function must be used to get (or build if params are needed) the path
// everytime we need to link to a page of the app
// WARNING: use this and do not put hardcoded paths in the code !
export const getPagePath = (id, parameters = {}) =>
  compose(
    ifElse(
      isNil,
      stubNull,
      compose(
        join('/'),
        map(part =>
          startsWith(':', part) && !isEmpty(parameters)
            ? propOr(part, part.slice(1), parameters)
            : part,
        ),
        split('/'),
      ),
    ),
    prop('path'),
    find(propEq('id', id)),
  )(routes)

export default routes
